import React from 'react';
import './StarMeter.css';

interface StarMeterProps {
  current: number;
  total: number;
  showLabel?: boolean;
}

const StarMeter: React.FC<StarMeterProps> = ({ 
  current, 
  total, 
  showLabel = true 
}) => {
  return (
    <div className="star-meter">
      {showLabel && (
        <div className="star-label">
          ⭐ Estrellitas: {current}/{total}
        </div>
      )}
      
      <div className="star-container">
        {Array.from({ length: total }, (_, index) => (
          <div
            key={index}
            className={`star ${index < current ? 'filled' : 'empty'}`}
          >
            ⭐
          </div>
        ))}
      </div>
    </div>
  );
};

export default StarMeter;
